
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import ResultParser from  "./../ResultParser/ResultParser";
import i18n from  "./../../Documental/Localization/i18n.js";

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
  

/**
 * PDF Struktuur: 
 * 
  Mental health self-assessment 
  
  Summary of the results 
  
  Recommendation text same as in app 
  
  Matrix (same as in app) 
  
  Insufficient data for evaluation: (add here problems) 
  No deviations detected: (add here problems) 
  Moderate deviations: (add here problems) 
  Significant deviations: (add here problems)
 * 
 */



class ResultsPdf {

  pdfResult: null | any = null;
  base64Decoded: null | any  = null;
  metaInfo: null | any = null;

  /**
   * 
   * 
   * @return void
   */
  constructor() {
    this.base64Decoded = null;
  }

  /**
   * 
   * 
   * @return void
  */
  generateBasedOnResults( results : ResultParser, metaInfoIn : any ) {
    let matrixItems = results.getMatrixItems();
    let decision    = results.getDecision();
    this.metaInfo   = metaInfoIn;

    let docDefinitionJson = this.createJsonForPdfMake( matrixItems, decision );
    this.pdfResult = pdfMake.createPdf( docDefinitionJson );

    var that = this;
    //if( this.pdfResult ){
      this.pdfResult.getBase64((data) => {
        that.base64Decoded = data;
      });
    //}
  }

  /**
   * 
   * 
   * @return void
  */
  generateBasedOnDemoData() {
    let parser = new ResultParser();
    let matrixItems = this.getMatrixItems();
    let decision = parser.getDecision();

    let docDefinitionJson = this.createJsonForPdfMake( matrixItems, decision );

    this.pdfResult = pdfMake.createPdf( docDefinitionJson );
    this.pdfResult.download( "self-report.pdf" );
    this.pdfResult.getBase64(( base64data : any  ) => {
      console.log( base64data );
    });
    /* 
    pdfMake.createPdf( docDefinitionJson ).getBase64(( base64data ) => {
      console.log( base64data );
    });
    */
  }

  download() {
    if( this.pdfResult !== null ){
      this.pdfResult.download( "self-report.pdf" );
      // this.pdfResult.open();
    }
  }

  hasPdfGenerated() {
    if( this.pdfResult !== null ){
      return true;
    }
    return false;
  }

  getBase64Encoded() {
    if( this.base64Decoded !== null ){
      return this.base64Decoded;
    }
    
    return '';
  }


  /**
   * 
   * @return void
  */
  createJsonForPdfMake( matrixItems, decision ) {

    let metainfoString = "";
    if( this.metaInfo !== null ){
      for( var ii in this.metaInfo ){
        metainfoString = metainfoString + this.metaInfo[ ii ] + ",  ";
      }
    }
    
    let matrixJson = this.getMatrixTableJson( matrixItems );
    let topicJson = this.getTopicTableJson( matrixItems );
    
    let inputJson = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [ 40, 60, 40, 60 ],
      info: {
        title: 'Summary',
        author: 'DM',
        keywords: metainfoString,
        subject: i18n.t('Mental health self-assessment')
      },
      content: [
        {
          svg: '<svg width="147" height="24" viewBox="0 0 147 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="146.4" height="24" y="-1" fill="url(#pattern0)"/><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_172_8477"  transform="scale(0.00409836 0.025)"/></pattern><image id="image0_172_8477" width="244" height="40"  xlink:href="data:image/png;base64,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"/></defs></svg>',
          
          width: 150,
          alignment: 'center',
          margin: [0, 20, 0, 20]
        },
        
        {
          text: i18n.t('Mental health self-assessment'), 
          style: 'header',
          alignment: 'center'
        },
        {
          text: i18n.t( "Summary of the results" ), 
          alignment: 'center',
          margin: [0, 10, 0, 20]
        },
        {
          text: decision.finalSuggestionTitle, 
          style: 'subheader', 
          alignment: 'center',
          margin: [0, 10, 0, 30]
        },
        matrixJson,
        topicJson
      ],
      styles: {
        header: {
          fontSize: 24,
          bold: true,
          margin: [0, 25, 0, 15]
        },
        subheader: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 10]
        },
        tableExample: {
          margin: [150, 0, 0, 25 ],
          alignment: 'center',
          fillColor: 'transparent' 
        }
      },
      defaultStyle: {
        alignment: 'left'
      }
      
    };
    
    return inputJson;
  }


  /**
   * Get topics grouped by following: 
   * 
   * Insufficient data for evaluation: (add here problems) 
   * 
   * No deviations detected: (add here problems) 
   * Moderate deviations: (add here problems) 
   * Significant deviations: (add here problems)
   * 
   * @return object
   */
   getTopicTableJson( matrixItems ) {

    let topicJson: any= [];
    let parser = new ResultParser();
    let grouped = parser.getMatrixTopicsGroupedForPdf( matrixItems );

    console.log( grouped );

    for( var j in grouped ){
      let h2 = {
        text: grouped[ j ].content, 
        style: 'subheader'
      };
      topicJson.push( h2 );

      let topicsInGroup: any = [];
      let isFirst = true;

      for( var ii in grouped[ j ].topics ){
        let comma = ", ";
        if( isFirst ){
          comma = "";
        }
        let oneTopic = {
          text: comma + grouped[ j ].topics[ ii ].topic + " (" + grouped[ j ].topics[ ii ].letter + ")",
          lineHeight: 1.5
        };
        topicsInGroup.push( oneTopic );
        // topicJson.push( oneTopic );
        isFirst = false;
      }

      topicJson.push( {
        text: topicsInGroup
      } );
    }    

    return topicJson;
  }


  /**
   * 
   * @return object
   */
   getMatrixTableJson( matrixItems ) {
    
    let emptyArr: any = [];

    let matrixJson = {
      style: 'tableExample',
      layout: 'noBorders',
      table: {
        layout: 'noBorders',
        heights: 50,
        widths: [50, 50, 50, 50],
        body: emptyArr
      }
    }
    
    let rowCnt = 0;
    let rowData: any = [];

    /* eslint-disable */
    for( var ii in matrixItems ){
      rowCnt++;
      
      let cellData = {
        fillColor: matrixItems[ ii ].useHTMLcolor,
        text: matrixItems[ ii ].letter,
        width: 45,
        height: 45,
        color: 'white',
        lineHeight: 2
      };

      rowData.push( cellData );

      //complete row
      if( rowCnt > 3 ){
        let compactArray: any = rowData.filter(function (item: any) {
          return item !== undefined;
        });

        matrixJson.table.body.push( compactArray );/* eslint-disable-line */
        rowData = [];
        rowData.length = 0;
        rowCnt = 0;
      }
    }

    // Add final row ...
    if( rowData.length > 0 ){
      let compactArray = rowData.filter(function (item) {
        return item !== undefined;
      });

      matrixJson.table.body.push( compactArray );/* eslint-disable-line */
    }
    /* eslint-enable */
    return matrixJson;
  }


  getMatrixItems(){
    let matrixItems: any = [];

    // fake data for design testing
    let parser = new ResultParser();

    for ( let i = 1; i <= 16; i++) {
      let obj = parser.getMatrixBaseRecord();

      obj.letter = 'S';
      obj.topic = 'Stress';
      obj.problemDisplay = "Stress";
      obj.content = "Insufficient data for evaluation";
      obj.priority = 'urgent';
      obj.priorityColor = 'green';
      obj.priorityColorNr = 1;
      
      matrixItems.push( obj );
    }
    
    matrixItems[ 4 ].priorityColorNr = 4;
    matrixItems[ 4 ].priorityColor = 'red';
    matrixItems[ 4 ].useHTMLcolor ="#f83918";
    matrixItems[ 4 ].problemDisplay = 'Functioning';
    matrixItems[ 4 ].letter = 'F';
    
    matrixItems[ 7 ].priorityColorNr = 3;
    matrixItems[ 7 ].priorityColor = 'orange';
    matrixItems[ 7 ].useHTMLcolor ="#F46F21";
    matrixItems[ 7 ].problemDisplay = 'Obsessions';
    matrixItems[ 7 ].letter = 'Ob';
    

    matrixItems[ 12 ].priorityColorNr = 0;
    matrixItems[ 12 ].priorityColor = '';
    matrixItems[ 12 ].problemDisplay = 'Nullable';
    matrixItems[ 12 ].letter = 'Nu';

    matrixItems[ 10 ].priorityColorNr = 2;
    matrixItems[ 10 ].priorityColor = 'yellow';
    matrixItems[ 10 ].useHTMLcolor ="#ffdd6d";
    matrixItems[ 10 ].problemDisplay = 'Safety';
    matrixItems[ 10 ].letter = 'Sa';
    
    matrixItems[ 11 ].priorityColorNr = 2;
    matrixItems[ 11 ].priorityColor = 'yellow';
    matrixItems[ 11 ].useHTMLcolor ="#ffdd6d";
    matrixItems[ 11 ].problemDisplay = 'Cognitive ability';
    matrixItems[ 11 ].letter = 'Co';

    
    return matrixItems;
  }

}


export default ResultsPdf;